
// src/graphql/customQueries.ts

export const getTripDetails = /* GraphQL */ `
  query FetchTripDetails($tripId: ID!) {
    getTripDetails(tripId: $tripId) {
      id
      tripName
      description
      startDate
      endDate
      createdBy
      creatorName
      storageUsed
      members {
        id
        userId
        role
        userName
        createdAt
        updatedAt
      }
      photos {
        id
        fileName
        s3Key
        uploadedBy
        uploaderName
        status
        fileSize
        contentType
        thumbnailS3Key
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      userRole
    }
  }
`;

export const listUserTrips = /* GraphQL */ `
  query CustomTripsByCreatedBy($createdBy: ID!) {
    tripsByCreatedBy(createdBy: $createdBy) {
      items {
        id
        tripName
        description
        startDate
        endDate
        createdBy
        createdAt
        updatedAt
        photos {
          items {
            id
            s3Key
            fileName
            status
            createdAt
          }
        }
      }
    }
  }
`;

export const listTripsWithPhotos = /* GraphQL */ `
  query CustomListTrips($filter: ModelTripFilterInput, $limit: Int, $nextToken: String) {
    listTrips(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tripName
        description
        startDate
        endDate
        createdBy
        createdAt
        updatedAt
        photos {
          items {
            id
            s3Key
            fileName
            uploadedBy
            status
            createdAt
          }
        }
      }
      nextToken
    }
  }
`;

export const listUserTripsWithPhotos = /* GraphQL */ `
  query CustomTripMembersByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTripMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tripMembersByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        role
        trip {
          id
          tripName
          description
          startDate
          endDate
          createdBy
          createdAt
          updatedAt
          photos {
            items {
              id
              s3Key
              fileName
              status
              createdAt
            }
          }
        }
      }
      nextToken
    }
  }
`;

export const getUserWithStorage = /* GraphQL */ `
  query GetUserWithStorage($id: ID!) {
    getUser(id: $id) {
      id
      name
      email
      phoneNumber
      storageTier
      storageUsed
      createdAt
      updatedAt
    }
  }
`;

// src/graphql/customQueries.ts - add this query
export const getUserTripsWithStorage = /* GraphQL */ `
  query GetUserTripsWithStorage($userId: ID!) {
    tripMembersByUserId(userId: $userId) {
      items {
        trip {
          id
          tripName
          description
          startDate
          endDate
          storageUsed
          createdBy
          photos {
            items {
              id
            }
          }
          createdAt
        }
      }
    }
  }
`;

// src/graphql/customQueries.ts
// Add this query to your existing customQueries.ts file

export const processInvitationCustom = /* GraphQL */ `
  query ProcessInvitationCustom($tripId: ID!, $token: String) {
    processInvitation(tripId: $tripId, token: $token) {
      trip {
        id
        tripName
        description
        startDate
        endDate
        createdBy
        creatorName
        storageUsed
        members {
          id
          userId
          role
          userName
          createdAt
          updatedAt
        }
        photos {
          id
          fileName
          s3Key
          uploadedBy
          uploaderName
          status
          fileSize
          contentType
          thumbnailS3Key
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        userRole
      }
      membership {
        id
        userId
        role
        userName
        createdAt
        updatedAt
      }
      invitationProcessed
      message
    }
  }
`;